module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "VPS-9"
    }
  }, [_c('h2', {
    staticClass: "chap_head"
  }, [_vm._v("RAILWAY MAP OF SCOTLAND")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/9.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("The northern section")]), _vm._v(" of this two-section map, converted from colour to black and white, shows the railway lines of Scotland as they were in the 1980s. These lines are shown in black. The map is a modified version of J. & W. Emslie’s "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Official Railway Map of Scotland")]), _vm._v(", London, 1941, with the title panel removed. The closed lines are shown in grey and closed stations, some of which appear in these photographs, can also be seen. This two-section map is reproduced with the permission of the National Library of Scotland and is used under the terms of the Creative Commons Attribution (CC-BY) licence.")])])]), _c('a', {
    attrs: {
      "id": "VPS-10"
    }
  }, [_c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/10.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("The southern section")]), _vm._v(" of this two-section map, converted from colour to black and white, shows the railway lines of Scotland as they were in the 1980s. These lines are shown in black. Some lines in the Glasgow area are omitted for clarity. The map is a modified version of J. & W. Emslie’s "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Official Railway Map of Scotland")]), _vm._v(", London, 1941, with the title panel removed. The closed lines are shown in grey and closed stations, some of which appear in these photographs, can also be seen. This two-section map is reproduced with the permission of the National Library of Scotland and is used under the terms of the Creative Commons Attribution (CC-BY) licence.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-76182ad3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/006_FM1.vue
// module id = 75
// module chunks = 0